import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Collection from './components/Locations'
import Object from './components/Location'

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

export default ({match, locations, states, kioskMode, reloadPage, reloadShell, scannedCode,userAccess}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection locations={locations} states={states} userAccess={userAccess} reloadPage={reloadPage} kioskMode={kioskMode}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:location/:bound_book?`}>
				<Object baseUrl={`${match.url}`} kioskMode={kioskMode} />
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
